import React from "react";

const MyReview = () => {
  return (
    <>
      <h2>My Reviews</h2>
    </>
  );
};

export default MyReview;
